import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GatewayShell from "./GatewayShell";
import GatewayStepProgress from "./GatewayStepProgress";
import { getDestinationContext } from "./destinationEngine";
import { resolveRedirectUrl } from "../utilities/authRedirect";
import { getIdentityTransaction } from "./identityTransaction";

const registrationProgress = {
  "/signup": [1, 8],
  "/register": [1, 8],
  "/personal-details": [2, 8],
  "/choose-mail": [3, 8],
  "/create-password": [4, 8],
  "/captcha": [5, 8],
  "/enter-code": [6, 8],
  "/recovery-mail": [7, 8],
  "/review-info": [8, 8],
};

const recoveryProgress = {
  "/email-address": [1, 3],
  "/forgot-password": [2, 3],
  "/verify-phone-number": [2, 3],
  "/select-account": [3, 3],
};

export default function GatewayLegacyStep({ stage, title, body, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const referralApp = getIdentityTransaction()?.referralApp || "";
  const destination = getDestinationContext({ redirectUrl: resolveRedirectUrl(), referralApp });
  const progress = stage === "registration"
    ? registrationProgress[location.pathname]
    : recoveryProgress[location.pathname];

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/login");
  };

  return (
    <GatewayShell
      stage={stage}
      destinationLabel={destination.continuingLabel}
      title={title}
      body={body}
      focused
      onBack={handleBack}
    >
      <div className={`gatewayLegacyStep gatewayLegacyStep--${stage}`}>
        {progress ? <GatewayStepProgress current={progress[0]} total={progress[1]} /> : null}
        {children}
      </div>
    </GatewayShell>
  );
}
